import React from 'react';

import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import { Box } from '@mui/material';

type Props = {
  loading?: boolean;
  value?: undefined | string | null;
};
export default function HtmlPreviewBox({ loading, value }: Props) {
  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <Box
      component="iframe"
      sx={{
        height: '100%',
        width: '100%',
        display: 'block',
        border: '0 none transparent',
      }}
      srcDoc={value ?? undefined}
    />
  );
}
